import { render, staticRenderFns } from "./styleTab.vue?vue&type=template&id=94802242&scoped=true&"
import script from "./styleTab.vue?vue&type=script&lang=js&"
export * from "./styleTab.vue?vue&type=script&lang=js&"
import style0 from "./styleTab.vue?vue&type=style&index=0&id=94802242&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94802242",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ljz/work-project/bi-base/biDashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94802242')) {
      api.createRecord('94802242', component.options)
    } else {
      api.reload('94802242', component.options)
    }
    module.hot.accept("./styleTab.vue?vue&type=template&id=94802242&scoped=true&", function () {
      api.rerender('94802242', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settingPanel/styleTab.vue"
export default component.exports